import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';

import { Dashboard as DashboardLayout } from 'layouts';

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(2)
  },
  item: {
    height: '100%'
  }
});

class RecoveryPrice extends Component {
  render() {
    const { classes, title, children, menu, menuTitle, breadcrumbs, beforeMainContent, breadcrumbsObject, titleComponent } = this.props;

    return (
      <DashboardLayout 
        titleComponent={titleComponent}
        specialMenu={menu}
        specialMenuTitle={menuTitle}
        title={title}
        breadcrumbs={breadcrumbs}
        beforeMainContent={beforeMainContent}
        breadcrumbsObject={breadcrumbsObject}
      >

        <div className={classes.root}>
          {children}
        </div>

      </DashboardLayout>
    );
  }
}

export default withStyles(styles)(RecoveryPrice);
